import { render, staticRenderFns } from "./putAccount.vue?vue&type=template&id=beff3db4"
import script from "./putAccount.vue?vue&type=script&lang=js"
export * from "./putAccount.vue?vue&type=script&lang=js"
import style0 from "./putAccount.vue?vue&type=style&index=0&id=beff3db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports